import browserClient from '@slardar/web';
import { resourceAnalyzer } from '@slardar/integrations/dist/resourceAnalyzer';
import { isProduction, isExternalProd } from './env';
export default function initSlardar() {
  if (!isProduction) return;
  var analyzer = resourceAnalyzer;
  browserClient.init({
    bid: 'arco_themes',
    env: isExternalProd ? 'public' : 'private',
    integrations: [analyzer()]
  });
  browserClient.start();
}